import {useEffect} from 'react';

export const useFavicon = () => {
    useEffect(() => {
      const domain = window.location.origin;
      let faviconUrl = "";
  
      if (domain.includes(process.env.REACT_APP_TYNO_AUTH_DOMAIN_URL)) {
        faviconUrl = "/images/tyno-ai.ico";
      } else if (domain.includes(process.env.REACT_APP_AUTH_DOMAIN_URL)) {
        faviconUrl = "/images/eprocessify-icon.png";
      }
  
      const link =
        document.querySelector("link[rel~='icon']") ||
        document.createElement("link");
      link.rel = "icon";
      link.href = faviconUrl;
  
      document.head.appendChild(link);
    }, []);
};